'use strict';

export default class AdminController {
  /*@ngInject*/
  constructor(User, dialogs, Auth, Config) {
    // Use the User $resource to fetch all users
    this.users = User.query();
    this.dialogs = dialogs;
    this.isSuperAdmin = Auth.isSuperAdminSync;
    this.roles = Config.getPlatformConfig().getUserRoles();
    this.Auth = Auth;
  }

  patchUserRoles(user) {
    this.Auth.patchUserRoles(user);
  }

  delete(user) {

    var userStr = "<br/><br/><b>" + user.firstName + ' ' + user.lastName + "</b>";
    var dlg = this.dialogs.confirm("Delete user?", "Do you really, really, really want to delete this user?" + userStr);
    dlg.result.then(() => {
      /* Delete the user */
      user.$remove();
      this.users.splice(this.users.indexOf(user), 1);
    }, () => {
      // Cancel
    });

  }
}



// WEBPACK FOOTER //
// ./client/~ap/app/admin/user-list/admin.controller.js